import logo from '../../img/ns_logo.png';
import logo_light from '../../img/logo_light.png';
import CartCounter from '../style-components/CartCounter';
import MenuItem from '../style-components/MenuItem';
import ClientMobile from './ClientMobile';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { animateScroll as scroll, scroller } from 'react-scroll';
import { useTextService } from '../../services/useTextService';
import { GB } from 'country-flag-icons/react/3x2';
import { LV } from 'country-flag-icons/react/3x2';

function HeaderClient({ mobile }) {
  const [isHome, setIsHome] = useState(false);
  const [isSubmenuOpen, setSubmenuOpen] = useState(false);
  const [scrollToVeikals, setScrollToVeikals] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { getPlainValueByTag } = useTextService();

  useEffect(() => {
    setIsHome(location.pathname === '/');
  }, [location]);

  useEffect(() => {
    setSubmenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (scrollToVeikals && isHome) {
      scroller.scrollTo('veikals', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -100, // Scrolls to 100px above the element
      });
      setScrollToVeikals(false);
    }
  }, [scrollToVeikals, isHome]);

  const handleVeikalsClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      setScrollToVeikals(true);
      navigate('/');
    } else {
      scroller.scrollTo('veikals', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -100, // Scrolls to 100px above the element
      });
    }
  };

  const handleLogoClick = () => {
    if (isHome) {
      scroll.scrollToTop({
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
      });
    } else {
      navigate('/');
    }
  };

  useEffect(() => {
    if (location.hash === '#veikals') {
      scroller.scrollTo('veikals', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -100, // Scrolls to 100px above the element
      });
    }
  }, [location]);

  // Add this after your existing useState declarations
  const [currentLang, setCurrentLang] = useState(localStorage.getItem('lang') || 'lv');

  // Add these handler functions after your existing handlers
  const handleLanguageSwitch = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem('lang', lang);
    window.location.reload(); // Optional: if your text service needs a refresh
  };

  return (
    <div className={`header-container ${isHome ? 'light' : ''}`}>
      {mobile ? (
        <ClientMobile 
          isHome={isHome}
          currentLang={currentLang}
          handleLanguageSwitch={handleLanguageSwitch}
        />
      ) : (
        <>
          <div className="top-bar">
            <div className="search flex gap-10 padding-10-left">
              <GB
                title="English"
                className={`language-flag ${currentLang === 'en' ? 'active' : ''}`}
                onClick={() => handleLanguageSwitch('en')}
                style={{ cursor: 'pointer' }}
              />
              <LV
                title="Latviski"
                className={`language-flag ${currentLang === 'lv' ? 'active' : ''}`}
                onClick={() => handleLanguageSwitch('lv')}
                style={{ cursor: 'pointer' }}
              />
            </div>
            <div className="logo" onClick={handleLogoClick}>
              {isHome ? (
                <img src={logo_light} alt="NoraSpora" />
              ) : (
                <img src={logo} alt="NoraSpora" />
              )}
            </div>
            <div className={`header-cart ${isHome ? 'light' : ''}`}>
              <CartCounter />
            </div>
          </div>
          <div className="menu padding-10-top padding-10-bottom">
            <div className="menu-item-with-submenu">
                <MenuItem text={getPlainValueByTag("menu-veikals")} onClick={handleVeikalsClick} />
            </div>
            <MenuItem text={getPlainValueByTag("menu-instrukcija")} link="/instrukcija" />
            <MenuItem text={getPlainValueByTag("menu-jautajumi")} link="/jautajumi" />
            <MenuItem text={getPlainValueByTag("menu-par-mums")} link="/about" />
            <MenuItem text={getPlainValueByTag("menu-kontakti")} link="/contacts" />
          </div>
        </>
      )}
    </div>
  );
}

export default HeaderClient;